const state = {
  isApiLoginStatus: false,      // 登陆状态
  userInfo: {},                 // 用户信息
  userId: null,                 // 用户id
  appId: 'wx7dff126205e4b443',  // 少年得到微信公众号APPID
  isFocusWxcode: true,          // 是否关注了少年得到微信公众号,默认已关注
  wxUserInfo: {
    nickname: '',
    headimgurl: ''
  },                            // 微信信息
  serverDate: {},   // 服务器时间
};
export default state;
